import { Box } from '@mantine/core';
import { STANDARD_SIDEBAR_WIDTH } from './useDragAnimation';

const COLLAPSE_TRANSITION = 'width 0.25s ease-out, opacity 0.2s ease-out';
const INNER_COLLAPSE_TRANSITION = 'transform 0.25s ease-out';

type Props = {
  children: React.ReactNode;
  style?: React.CSSProperties;
  width: number;
  isDragging?: boolean;
  collapsed?: boolean;
};

export function AppSidebar({ children, style, width, isDragging, collapsed }: Props) {
  const resolvedWidth = collapsed ? '0px' : `${width}px`;

  return (
    <Box
      h="100%"
      w={resolvedWidth}
      pos="relative"
      display="flex"
      style={{
        backgroundColor: 'rgba(255, 119, 28, 0.4)',
        borderRadius:
          'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
        transition: isDragging ? 'none' : COLLAPSE_TRANSITION,
        overflow: 'hidden',
        flexShrink: 0,
        opacity: collapsed ? 0 : 1,
        ...style,
      }}
    >
      <Box
        h="100%"
        w="100%"
        pos="relative"
        style={{
          borderRadius:
            'var(--mantine-spacing-xxl) var(--mantine-spacing-xxl) var(--mantine-spacing-xxxl) var(--mantine-spacing-xxxl)',
          overflow: 'hidden',
          transition: isDragging ? 'none' : INNER_COLLAPSE_TRANSITION,
          minWidth: `${STANDARD_SIDEBAR_WIDTH}px`,
          transform: collapsed ? 'translateX(100%)' : 'translateX(0)',
        }}
      >
        {children}
      </Box>
    </Box>
  );
}
